import React, { Component } from "react";
import "../css/navbar.css";
import "../css/art.css";
import { Link } from "react-router";
import Slider from "../components/Slider";

class Art extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }
  componentWillMount() {
    var arr = [];
    var list = [];
    var chunk_size = 4;
    var thisState = this;
    fetch("/api/getexhibitions", {
      method: "GET"
    })
      .then(resp => resp.json())
      .then(function(data) {
        arr = Object.keys(data.exhibitions).map(function(obj) {
          return data.exhibitions[obj];
        });
        var exhibitionsCount = Object.keys(data.exhibitions).length;
        if (exhibitionsCount % 4 !== 0) {
          if (exhibitionsCount <= 4) {
            var val = 4 - exhibitionsCount;
            for (var i = 0; i < val; i++) {
              arr.push({
                location: "",
                url: "",
                thumb_url: ""
              });
            }
          } else {
            val = 4 - Math.floor(exhibitionsCount % 4);
            for (i = 0; i < val; i++) {
              arr.push({
                location: "",
                url: "",
                thumb_url: ""
              });
            }
          }
        }
        for (i = 0; i < arr.length; i += 4) {
          list.push(
            <div key={i}>
              <Table
                art={arr.exhibition_name}
                index={i}
                array={arr.slice(i, i + chunk_size)}
              />
            </div>
          );
        }
        thisState.setState({ data: list });
      });
  }

  render() {
    return (
      <div className="main desktopview">
        <div className="slider">
          <Slider showNav={this.state.data.length > 4 ? true : false}>
            {this.state.data}
          </Slider>
        </div>
      </div>
    );
  }
}
export default Art;

class Table extends Component {
  render() {
    return (
      <div>
        <table>
          <tbody>
            <tr>
              {this.props.array[0].exhibition_status === "0"
                ? <ColValid data={this.props.array[0]} />
                : <ColDisabled data={this.props.array[0]} />}
              {this.props.array[1].exhibition_status === "0"
                ? <ColValid data={this.props.array[1]} />
                : <ColDisabled data={this.props.array[1]} />}
            </tr>
            <tr>
              {this.props.array[2].exhibition_status === "0"
                ? <ColValid data={this.props.array[2]} />
                : <ColDisabled data={this.props.array[2]} />}
              {this.props.array[3].exhibition_status === "0"
                ? <ColValid data={this.props.array[3]} />
                : <ColDisabled data={this.props.array[3]} />}
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

function ColValid(props) {
  return (
    <td>
      <Link to={"/art/" + props.data.exhibition_name}>
        <figure className="art image-container">
          <figcaption>
            <div>
              <h2>
                {props.data.exhibition_name}
              </h2>
              <p>
                {props.data.year}
              </p>
            </div>
          </figcaption>
        </figure>
      </Link>
    </td>
  );
}
class ColDisabled extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseOver: false
    };
    this.handleOnMouseOver = this.handleOnMouseOver.bind(this);
    this.handleOnMouseOut = this.handleOnMouseOut.bind(this);
  }
  handleOnMouseOver() {
    this.setState({ mouseOver: true });
  }
  handleOnMouseOut() {
    this.setState({ mouseOver: false });
  }
  render() {
    var name = this.props.data.exhibition_name
      ? this.props.data.exhibition_name
      : "...";
    return (
      <td>
        <figure
          className="image-container-disabled"
          style={{
            backgroundSize: "cover",
            opacity: ".6",
            background: "rgb(242, 242, 242)"
          }}
          onMouseOver={this.handleOnMouseOver}
          onMouseLeave={this.handleOnMouseOut}
        >
          <figcaption>
            <div>
              {!this.state.mouseOver
                ? <p>
                    {name}
                  </p>
                : <p>Coming soon</p>}
            </div>
          </figcaption>
        </figure>
      </td>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Art.js